import { toCommas } from "../../../utils/General";
import { useSelector } from "react-redux";

const CreditComponent = () => {
  const Credit = useSelector((state) => state?.data?.Credit);

  return (
    <p className="font-semibold text-center text-xs">
      مانده اعتبار سرویس ها: {toCommas(Credit)} ریال
    </p>
  );
};

export default CreditComponent;